<template>
  <v-dialog v-model="show" width="700">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        Detail
      </v-card-title>

      <div style="text-align:left;margin-left:10%;padding:20px;">
        <table >
          <tr>
            <td>Date: </td>
            <td>{{ detailData.date }}</td>
          </tr>
          <tr>
            <td>Status: </td>
            <td>{{ getStatus(detailData.status) }}</td>
          </tr>
          <tr v-show="detailData.type == 1">
            <td>Duration: </td>
            <td>{{ secondsToHms(detailData.duration) }}</td>
          </tr>
          <tr v-if="detailData.type != 3">
            <td>Calling Time: </td>
            <td>{{ detailData.calling_time }}</td>
          </tr>
          
         
          <tr>
            <td>Type: </td>
          
            <td v-if="detailData.status==1"> 
              <span v-if="detailData.type == 1" style="background-color: #1E90FF; color: white;"> 
                by-phone
              </span>
              <span v-if="detailData.type == 2" style="background-color: blue; color: white;"> 
                in-person
              </span>
              <span  v-if="detailData.type == 3">
                <span style="background-color: #24b014; color: white;"> 
                  by-inno-dot 
                </span> 
                <label>( {{ detailData.work_type }} )</label>   
              </span>
             
            </td>

            <!-- cannot call -->
            <td v-else> 
              <span v-if="detailData.type == 1" style="background-color: red; color: white;"> 
                by-phone
              </span>
              <span v-if="detailData.type == 3" style="background-color: #24b014; color: white;"> 
                by-inno-dot
              </span> 
            </td>

          </tr>
         

          <tr v-show="detailData.type == 2">
            <td>Signature: </td>
            <td>
              <img
                class="materialboxed"
                :src="'data:image/png;base64, ' + detailData.signature"
                alt
                style="width:200px;height:200px;"
              />
            </td>
          </tr>
        </table>
      </div>

      <div
        class="row side_effect_container"
        v-show="detailData.status == 1"
        style="margin-left:10%;"
      >
        <h4>Side Effect: </h4>

        <!-- from inno dot side effect -->
        <p v-if="detailData.major_side_effects" style="margin-left:20px;">{{ detailData.major_side_effects }}</p>

        <p v-else style="margin-left:20px;">{{ detailData.low_side_effect }}</p>
        <!-- <p
          v-for="(item, index) in detailData.raw_low_side_effect"
          v-bind:key="item.id"
        >
          {{ index + 1 }} {{ item.name }}
        </p> -->
      </div>
      <div
        class="row side_effect_container"
        v-show="detailData.status == 1"
        style="margin-left:10%;text-align:left"
      >
        <h4>Action: </h4>
        <p style="margin-left:90px;">{{ detailData.high_side_effect }}</p>
        <!-- <p
          v-for="(item, index) in detailData.raw_high_side_effect"
          v-bind:key="item.id"
        >
          {{ index + 1 }} {{ item.name }}
        </p> -->
      </div>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="show = false">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["show", "detailData"],
  data() {
    return {
      //   dialog: false,
    };
  },
  methods: {
    getStatus(id) {
      switch (parseInt(id)) {
        case 1:
          return "Visited";

        case 2:
          return "Cannot call";

        case 0:
          return "Pending";
      }
    },
    secondsToHms(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);
      var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
      return hDisplay + mDisplay + sDisplay;
    },
  },
};
</script>
<style scoped>
.side_effect_container {
  padding: 20px;
}
</style>
